<template>
	<div class="home">
		<HomeLanding />
	</div>
</template>

<script>
import HomeLanding from './components/home_landing.vue'

export default {
	name: 'HomeView',
	components: {
		HomeLanding
	}
}
</script>
